import script from "./PermissionManager.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionManager.vue?vue&type=script&setup=true&lang=js"

import "./PermissionManager.vue?vue&type=style&index=0&id=44c239a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44c239a2"]])

export default __exports__